import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import Cookies from "js-cookie";
import { BASE_URL } from "./Config";
import { ToastContainer, toast } from "react-toastify";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import "react-toastify/dist/ReactToastify.css";
import "./Login.css";

export default function Login() {
  const [email, setloginEmail] = useState("");
  const [password, setloginpass] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [UserIp, setUserIP] = useState("");
  const location = useLocation();
  const navigate = useNavigate();
  const from = location.state?.from?.pathname || "/";
  //console.log("location.state:", location.state);


  const getUserIP = async () => {
    try {
      const res = await axios.get("https://api.ipify.org?format=json");

      setUserIP(res.data.ip);

      return res.data.ip;



    } catch (err) {
      console.error("IP fetch error", err);
      return null;
    }
  };



  useEffect(() => {
    const userId = Cookies.get("user_id");
    if (userId) {
      navigate(from, { replace: true }); // Redirect to previous page
    }

    getUserIP();
  }, [navigate, from]);




  const handleLogin = async (e) => {
    e.preventDefault();

    if (!email || !password) {
      toast.error("Please fill in all fields.");
      return;
    }

    setLoading(true);

    try {
      const res = await axios.post(`${BASE_URL}/user_login.php?type=login`, {
        login: email,
        password,
        UserIp
      });

      //  console.log("login status", res);

      if (res.data.success) {
        toast.success("Login Successfully!");
        Cookies.set("user_id", res.data.user_id, {
          expires: 7,
          secure: true, // HTTPS only
          sameSite: "Strict", // prevent CSRF
        });
        Cookies.set("username", res.data.name, {
          expires: 7,
          secure: true, // HTTPS only
          sameSite: "Strict", // prevent CSRF
        });
        Cookies.set("token", res.data.token, {
          expires: 7,
          secure: true, // HTTPS only
          sameSite: "Strict", // prevent CSRF
        });

        navigate(from, { replace: true });
      } else {
        toast.error(res.data.message || "Login failed. Please try again.");
      }
    } catch (error) {
      console.error("Login Error:", error.response?.data || error);
      toast.error("An error occurred. Please try again.");
    }

    setLoading(false);
  };

  return (
    <div className="container pb-5">
      <div className="row">
        <div className="col-12 pt-5">
          <div className="logo">
            <Link to="/">
              <img
                src={`${BASE_URL}/images/fastrade_logo.jpg`}
                style={{ width: "220px" }}
                alt="Fast Trade "
              />
            </Link>
          </div>
        </div>

        <div className="col-12 pt-4 alert login_alert">
          <div className="login-form">
            <form onSubmit={handleLogin}>
              <div className="form-page">
                <h2>Login</h2>
                <p>
                  New to Fast Trade?{" "}
                  <Link
                    to="/register-number"
                    className="redirect_link"
                    style={{ fontWeight: "600" }}
                  >
                    Register Now!
                  </Link>
                </p>

                <div className="inputs pt-3">
                  <input
                    type="text"
                    placeholder="Username, Email, PhoneNumber"
                    className="number_input"
                    value={email}
                    onChange={(e) => setloginEmail(e.target.value)}
                  />

                  <div style={{ position: "relative" }}>
                    <input
                      type={showPassword ? "text" : "password"}
                      placeholder="Enter Password"
                      className="number_input"
                      value={password}
                      onChange={(e) => setloginpass(e.target.value)}
                    />
                    <span
                      onClick={() => setShowPassword(!showPassword)}
                      style={{
                        position: "absolute",
                        right: "15px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        cursor: "pointer",
                        color: "#555",
                      }}
                    >
                      {showPassword ? <FaEyeSlash /> : <FaEye />}
                    </span>
                  </div>
                </div>

                <div className="forget-pass-link pt-3">
                  <Link to="/forget-pass">Forgotten password?</Link>
                </div>

                <div className="submit-btn pt-3">
                  <input
                    type="submit"
                    value={loading ? "Logging in..." : "Login"}
                    className="btn btn-primary"
                    style={{
                      width: "100%",
                      backgroundColor: "#128DE5",
                      padding: "10px",
                      marginBottom: "15px",
                      fontWeight: "600",
                    }}
                    disabled={loading}
                  />
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
}
